import { ErrorBoundary } from '@sentry/react';
import { ButtonIcon, Typography, Stacked } from '@statsbomb/kitbag-components';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useOutlet, useSearchParams } from 'react-router-dom';
import { SETTINGS_PANEL } from '@/consts/searchKeys';
import { useIsTouchDevice } from '@/hooks/useIsTouchDevice';
import { useUpdateQueryString } from '@/hooks/useUpdateQueryString';
import { GeneralErrorBoundaryFallback } from '../errorBoundary/ErrorBoundaryFallback';

/**
 * This component should be used to hold the controls which
 * appear in the top heading of our 50/50 layout.
 */
export const SectionControlsWrapper = ({
  heading,
  headerComponent,
  children,
}: {
  heading: string;
  headerComponent?: ReactNode;
  children?: ReactNode;
}) => {
  const { t } = useTranslation('general');
  const [searchParams] = useSearchParams();
  const updateQueryString = useUpdateQueryString(searchParams);
  const outlet = useOutlet();
  const isTouch = useIsTouchDevice();

  return (
    <ErrorBoundary fallback={<GeneralErrorBoundaryFallback />}>
      <header className="bg-canvas-tertiary-main max-h-10 box-border border-b border-canvas-secondary-main py-1 px-4">
        <Stacked>
          <Stacked>
            {outlet && !isTouch && (
              <Link to={`.?${updateQueryString([], [SETTINGS_PANEL])}`}>
                <ButtonIcon icon="DoubleChevronRight" size="small" displayText="right" variant="ghost">
                  {t('filters.other')}
                </ButtonIcon>
              </Link>
            )}
            <Typography variant="headingRegular" className="pr-2">
              {heading}
            </Typography>
          </Stacked>
          {headerComponent}
          <div className="ml-auto flex items-center gap-2">{children}</div>
        </Stacked>
      </header>
    </ErrorBoundary>
  );
};
